import { render, staticRenderFns } from "./LoginTwo.vue?vue&type=template&id=fba8a4f0&scoped=true"
import script from "./LoginTwo.vue?vue&type=script&lang=js"
export * from "./LoginTwo.vue?vue&type=script&lang=js"
import style0 from "./LoginTwo.vue?vue&type=style&index=0&id=fba8a4f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba8a4f0",
  null
  
)

export default component.exports